export default {
  "redemptionCodeRecord.title": "兑换码记录",
  "redemptionCodeRecord.column.no": "#序号",
  "redemptionCodeRecord.column.userNo": "用户编号",
  "redemptionCodeRecord.column.redemptionCode": "兑换码",
  "redemptionCodeRecord.column.channel": "渠道",
  "redemptionCodeRecord.column.amount": "金额",
  "redemptionCodeRecord.column.withdrawLimit": "提现限制",
  "redemptionCodeRecord.column.createTime": "创建时间",
  "redemptionCodeRecord.search.userNo": "用户编号",
  "redemptionCodeRecord.search.redemptionCode": "兑换码",
  "redemptionCodeRecord.search.channel": "渠道",
  "redemptionCodeRecord.tooltip.copy.userNo": "复制用户编号: {text}",
  "redemptionCodeRecord.tooltip.copy.redemptionCode": "复制兑换码: {text}",
  "redemptionCodeRecord.tooltip.showUserDetails": "显示用户详情",
  "redemptionCodeRecord.copy.success": "已复制到剪贴板",
};